import useSWR from "swr";

type MenuImages = {
  id: string;
  restaurant: string;
  menu_type: string;
  img: string;
  menu_num: string;
}[]
export const useFetchEnglishFoodMenuByRestaurantId = (restaurantId: string) => {
  const fetcherKey = restaurantId ? `menu/restaurants/${restaurantId}/food/english/` : null;
  const { data: foodMenuImages, error, isLoading } = useSWR<MenuImages>(fetcherKey)
  return { foodMenuImages, isLoading, error };
};